import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useProjectDetails from "./useProjectDetails";

import routes from "../utils/routes";
import toastService from "../services/toastService";


const useActiveProjectBlock = () => {
  const { projectDetails } = useProjectDetails();

  const navigate = useNavigate();
  
  useEffect(() => {
    if (projectDetails && !projectDetails.isActive) {
        toastService.error('This project is currently inactive!');
        navigate(routes.projectDetails.fullPath.replace(':projectId', projectDetails._id))
    }
  }, [projectDetails, navigate])
};

export default useActiveProjectBlock;
